export const environment = {
    production: false,
    apiUrl: 'https://sandbox-api.xpaxbooking.com/api/',
    bookingUrl: 'https://sandbox-booking.xpaxbooking.com/',
    s3Url: 'https://d1kiky0kovpclm.cloudfront.net/',
    liffBooking: '1661097932-KkkrXAAq',
};
